<template>
  <div>
    <v-row
      class="my-1 mr-2"
      align="center"
      justify="center"
      @click="showInfo = !showInfo"
      style="cursor: pointer"
    >
      <v-col cols="1">
        <v-icon
          v-if="
            therm.isConnected &&
            (therm.isBlocked || therm.alarmpoint >= therm.temp_now) &&
            !therm.isExternal
          "
          size="20"
          color="red"
          class="mr-2"
          >mdi-alert</v-icon
        >
        <v-icon
          v-else-if="therm.isConnected && therm.probeError"
          size="20"
          class="mr-2"
          color="amber"
          >mdi-alert-box</v-icon
        >
        <v-icon
          v-else
          size="15"
          class="mr-2"
          :color="therm.isConnected ? 'green' : 'grey'"
          >mdi-circle</v-icon
        >
      </v-col>
      <v-col cols="6">
        <span class="text-h6 font-weight-light">{{ therm.nome }}</span>
      </v-col>
      <v-col cols="5" class="d-flex justify-end align-center">
        <v-icon
          v-if="therm.isConnected && therm.isBurning && !therm.isBlocked"
          color="orange"
          class="ml-2 mb-1"
          >mdi-fire</v-icon
        >
        <span
          style="font-size: 20px; font-weight: 300"
          class="ml-2"
          :class="
            therm.isConnected && !therm.probeError ? tempColor + '--text' : ''
          "
          >{{
            therm.isConnected && !therm.probeError
              ? therm.temp_now.toFixed(1) + " °C"
              : "N/A"
          }}</span
        >
      </v-col>
    </v-row>
    <template v-if="showInfo">
      <v-row class="mb-4" align="center" no-gutters>
        <v-col cols="9" offset="1">
          <template v-if="!therm.isConnected">
            <span class="grey--text text--lighten-1 ml-2"
              >Disconnesso ({{ time_ago }})</span
            >
          </template>
          <template v-else>
            <span v-if="therm.isBlocked" class="red--text text--lighten-1 ml-2">
              <v-icon color="red" class="mr-2">mdi-alert</v-icon>
              Blocco Bruciatore
            </span>
            <span
              v-else-if="therm.probeError"
              class="amber--text text--lighten-1 ml-2"
            >
              <v-icon color="amber" class="mr-2">mdi-alert</v-icon>
              Errore Sonda
            </span>
            <span
              v-else-if="therm.alarmpoint >= therm.temp_now"
              class="red--text text--lighten-1 ml-2"
            >
              <v-icon color="red" class="mr-2">mdi-alert</v-icon>
              Allarme Temp.
            </span>

            <span v-else class="green--text text--lighten-1">
              <v-icon color="green" class="mr-2">mdi-check</v-icon>
              Nessuna Anomalia
            </span>
          </template>
        </v-col>
        <v-col cols="2" class="">
          <v-btn icon @click="$refs.infoBox.open()">
            <v-icon color="grey">mdi-information-variant</v-icon>
          </v-btn>
          <infoBox ref="infoBox" :therm="therm" />
        </v-col>
      </v-row>

      <v-row class="mb-4" no-gutters align="center">
        <v-col cols="11" offset="1">
          <v-icon class="mr-0" :color="therm.isConnected ? 'red' : 'grey'"
            >mdi-menu-up</v-icon
          >
          {{ therm.isConnected ? max_temp + " °C" : "N/A" }}
          <v-icon class="mr-0 ml-2" :color="therm.isConnected ? 'blue' : 'grey'"
            >mdi-menu-down</v-icon
          >
          {{ therm.isConnected ? min_temp + " °C" : "N/A" }}
          <v-icon
            class="mr-0 ml-2"
            :color="therm.isConnected ? 'orange' : 'grey'"
            >mdi-menu-right</v-icon
          >
          {{ therm.isConnected ? avg_temp + " °C" : "N/A" }}
        </v-col>
      </v-row>
      <template v-if="!therm.isExternal">
        <v-row class="mb-4" no-gutters>
          <v-col cols="11" offset="1">
            <v-icon class="mr-2" :color="therm.isConnected ? 'purple' : 'grey'"
              >mdi-clock</v-icon
            >
            <span>{{ burning_time }} </span>
            <v-icon
              class="mr-2 ml-2"
              :color="therm.isConnected ? 'teal' : 'grey'"
              >mdi-water</v-icon
            >
            <span>{{ therm.isConnected ? litri + " lit." : "N/A" }}</span>
          </v-col>
        </v-row>
        <v-row class="mb-4" no-gutters align="center">
          <v-col cols="9" offset="1" class="d-flex align-center">
            <v-icon class="mr-2" :color="therm.isConnected ? 'green' : 'grey'"
              >mdi-thermometer</v-icon
            >
            <span style="font-size: 16px" class="grey--text"
              >Setpoint:
              <span class="black--text"
                >{{ therm.setpoint.toFixed(1) }} °C</span
              >
            </span>
          </v-col>
          <v-col cols="2">
            <v-btn icon @click="$refs.setPointBox.open()">
              <v-icon color="grey">mdi-wrench</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mb-4" no-gutters align="center">
          <v-col cols="9" offset="1">
            <v-icon
              class="mr-2"
              :color="therm.isConnected ? 'amber' : 'grey'"
              >{{
                therm.pushEnabled ? "mdi-bell-ring" : "mdi-bell-off"
              }}</v-icon
            >
            <span style="font-size: 16px" class="grey--text">
              Allarme:
              <span class="black--text"
                >{{ therm.alarmpoint.toFixed(1) }} °C</span
              ></span
            >
          </v-col>
          <v-col cols="2">
            <v-btn icon @click="$refs.editBox.open()">
              <v-icon color="grey">mdi-cog</v-icon>
            </v-btn>
          </v-col>
          <setPointBox :therm="therm" ref="setPointBox" />
          <editBox :therm="therm" ref="editBox" />
        </v-row>
      </template>
    </template>

    <v-divider />
  </div>
</template>

<script>
import therm_element_mixin from "../mixin/therm_element_mixin";
import moment from "moment";
import setPointBox from "./set_point_box_mobile.vue";
import editBox from "./therm_edit_box_mobile.vue";
import infoBox from "../Desktop/therm_info_box.vue";
export default {
  name: "ThermElement",
  components: {
    setPointBox,
    editBox,
    infoBox,
  },
  mixins: [therm_element_mixin],
  props: {
    therm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showInfo: false,
    };
  },
  computed: {
    time_ago() {
      return this.therm.last_update
        ? moment.unix(this.therm.last_update).fromNow()
        : "-";
    },
  },
};
</script>